import { Box, Container, Typography, Grid } from '@mui/material';
import { School, VerifiedUser, ConnectWithoutContact } from '@mui/icons-material';

const features = [
    {
        icon: <VerifiedUser fontSize="large" color="primary" />,
        title: 'Vetted & Qualified Tutors',
        description: 'Every tutor on our platform undergoes a rigorous vetting process, ensuring you receive the highest quality education.',
    },
    {
        icon: <School fontSize="large" color="primary" />,
        title: 'Personalized Learning',
        description: 'Our tutors tailor their teaching methods to match your individual learning style, helping you achieve your academic goals faster.',
    },
    {
        icon: <ConnectWithoutContact fontSize="large" color="primary" />,
        title: 'Seamless Connectivity',
        description: 'Connect with your tutor through our state-of-the-art platform, designed for an interactive and effective online learning experience.',
    },
];

const WhyChooseUs = () => {
    return (
        <Box sx={{ py: { xs: 6, md: 10 }, bgcolor: 'background.paper' }}>
            <Container maxWidth="lg">
                <Typography component="h2" variant="h3" align="center" sx={{ mb: 8, fontWeight: '600' }}>
                    Why Ethio Future Tutor?
                </Typography>
                <Grid container spacing={5} justifyContent={"center"}>
                    {features.map((feature) => (
                        <Grid item key={feature.title} xs={12} md={4}>
                            {/* --- THIS IS THE FIX --- */}
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center', // This centers everything horizontally
                                textAlign: 'center',   // This ensures the text itself is centered if it wraps
                            }}>
                                <Box sx={{ mb: 2 }}>{feature.icon}</Box>
                                <Typography variant="h5" fontWeight="500" gutterBottom>
                                    {feature.title}
                                </Typography>
                                <Typography color="text.secondary">
                                    {feature.description}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default WhyChooseUs;